import styles from "./Experience.module.scss";
import photo from "../assets/experiencePhoto.jpg";

export const ExperiencePage = () => {
    return (
        <div className={styles.experience}>
            <div className={styles.title}>Dr. Oleg Torsunov</div>
            <div className={styles.content}>
                <div className={styles.contentText}>
                    <p className={styles.textListText}>
                        🍃 Dr. Torsunov has a PhD in Medical Science &
                        Psychology
                    </p>

                    <p className={styles.textListText}>
                        🍃 Dedicated 10 years in India to the study of Ayurveda
                        & is the author of more than 30 published books.
                    </p>

                    <p className={styles.textListText}>
                        🍃 Published a groundbreaking health and wellness guide
                        in 2023 and launched the mobile wellness app “MY
                        REVIVE.”
                    </p>
                    <p className={styles.textListText}>
                        🍃 In 2013, he founded the “Amrita” Health Center, later
                        established the Saraswati Educational Center, and
                        launched Vedas Radio.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Conducted over 1,000 successful personal
                        consultations. Each person received either an immediate
                        solution during the session or a clear action plan that
                        quickly guided them to success.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Over 1,000,000 people around the world have completed
                        his courses or attended his lectures.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Did a doctoral thesis on the ways of a healthy
                        lifestyle in 2012.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Was awarded the gold medal of the Academy of Natural
                        Sciences named after I.I. Mechnikov in Health and
                        Psychology for ‘Outstanding Contribution to
                        Strengthening the Wellness of the Nation’.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Was awarded the title of Professor of the
                        International Academy of Sobriety in 2011.
                    </p>
                    <p className={styles.textListText}>
                        🍃 Recipient of the 2018 “For the Good of the World”
                        award in Educational Literature for the book The Subtle
                        Structure of Man.
                    </p>
                </div>
                <div className={styles.contentPhoto}>
                    <img src={photo} />
                </div>
            </div>
        </div>
    );
};
